module.exports = __webpack_public_path__ + "img/circle-purple.907fb9e3.png";